import React, { Component } from "react";
import {
  Button,
  Table,
  Col,
  Input,
  Row,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Select from 'react-select';
import Pagination from "react-js-pagination";
import * as khachhangUserConstant from './constants'
import * as khachhangUserAction from './actions'
import { storedb } from '../../views/client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import { CheckboxExt } from "../controls/CheckboxExt"
class KhachhangUser extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    khachhangUserListRequest: PropTypes.func,
    khachhangUserUpdateRequest: PropTypes.func,
    khachhangUserDetailRequest: PropTypes.func,
    khachhangUser: PropTypes.shape({
      list: PropTypes.array,
      resultUser: PropTypes.array,
      listKhachHangUser: PropTypes.array,
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      StoreId: dbContext.getStoreId(),
      item: {},
      listUser: [],
      listKhachHangNotUser: [],
      listKhachHangUser: [],
      keyword: '',
      selectedOption: null,
      UserId: 0,
      formError: [],
      page: 1,
      per_page: 20,
      total_record: 0,
      khachHangIds: [],
      UnkhachHangIds: [],
      selectedAll: false,
      selectedAllUn: false
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page}, this.featchDetail);
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  checkedKhachHangAll = () => {
    let { listKhachHangNotUser, khachHangIds, selectedAll } = this.state;
    selectedAll = !selectedAll;
    khachHangIds =[];
    if (selectedAll) {
      if (listKhachHangNotUser && listKhachHangNotUser.length > 0) {
        listKhachHangNotUser.map((res, idx) => (
          khachHangIds.push(res.KhachHangId)
        ))
      }
    } else {
      khachHangIds = []
    }
    this.setState({ khachHangIds, selectedAll }, () => {
      $('.cb-item').prop('checked', selectedAll);
    });
  }
  UnCheckedKhachHangAll = () => {
    let { listKhachHangUser, UnkhachHangIds, selectedAllUn } = this.state;
    selectedAllUn = !selectedAllUn;
    UnkhachHangIds =[];
    if (selectedAllUn) {
      if (listKhachHangUser && listKhachHangUser.length > 0) {
        listKhachHangUser.map((res, idx) => (
          UnkhachHangIds.push(res.KhachHangId)
        ))
      }
    } else {
      UnkhachHangIds = []
    }
    this.setState({ UnkhachHangIds, selectedAllUn }, () => {
      $('.cb-item-un').prop('checked', selectedAllUn);
    });
  }
  
  handleKhachHangClick(option) {
    let { khachHangIds } = this.state;
    var index = khachHangIds.indexOf(option.KhachHangId);
    if (index !== -1) {
        khachHangIds.splice(index, 1);
    }
    else {
      khachHangIds.push(
       option.KhachHangId
      );
    }
    this.setState({ khachHangIds, selectedAll: false });
    $('.cb-item-all').prop('checked', false)
  }
  handleUnKhachHangClick(option) {
    let { UnkhachHangIds } = this.state;
    var index = UnkhachHangIds.indexOf(option.KhachHangId);
    if (index !== -1) {
      UnkhachHangIds.splice(index, 1);
    }
    else {
      UnkhachHangIds.push(
       option.KhachHangId
      );
    }
    $('.cb-item-un-all').prop('checked', false)
    this.setState({ UnkhachHangIds, selectedAllUn: false });
  }
  handleUserChange = selectedOption => {
    this.setState({ selectedOption });
    this.setState({ UserId: selectedOption.value,formError: "" }, () => {
      this.featchDetail();
    });
  };
  featchDetail = () => {
    const { khachhangUserDetailRequest } = this.props
    $('.cb-item').prop('checked', false);
    $('.cb-item-all').prop('checked', false);
    $('.cb-item-un').prop('checked', false);
    $('.cb-item-un-all').prop('checked', false);
    this.setState({ selectedAll: false ,selectedAllUn: false , khachHangIds: [], UnkhachHangIds: [] });
    var requestData = {
      keyword: this.state.keyword,
      StoreId: this.state.StoreId,
      UserId: this.state.UserId,
      page: this.state.page,
      per_page: this.state.per_page
    }
    return khachhangUserDetailRequest(requestData);
  }
  fetchListUser = () => {
    const { khachhangUserListRequest } = this.props
    var requestData = {
      StoreId: this.state.StoreId
    };
    return khachhangUserListRequest(requestData);
  }
  filterListKhachHangUser = (event) => {
    var updatedList = this.props.khachhangUser.listKhachHangUser;

    updatedList = updatedList.filter(function (item) {
      return (
        item.Ten.toLowerCase().search(event.target.value.toLowerCase()) !== -1 ||
        item.Ma.toLowerCase().search(event.target.value.toLowerCase()) !== -1 || 
        item.DienThoai.toLowerCase().search(event.target.value.toLowerCase()) !== -1
      )
    });
    this.setState({ listKhachHangUser: updatedList })
  }
  keyPress = (e) => {
    if(e.keyCode == 13){
       this.featchDetail()
    }
  }
  updateListKhachHangUser = (flag) => {
    let { formError,khachHangIds,UnkhachHangIds } = this.state;
    var listkh =[]
    if(flag == "add")
    {
      listkh = khachHangIds
      if(listkh.length<=0)
      {
        return;
      }
    }
    if(flag == "remove")
    {
      listkh = UnkhachHangIds
      if(listkh.length<=0)
      {
        return;
      }
    }
    formError = [];
    if (this.state.UserId && this.state.UserId > 0) {

      var requestData = {
        StoreId: this.state.StoreId,
        UserId: this.state.UserId || 0,
        KhachHangIds: listkh
      }
      this.props.khachhangUserUpdateRequest(requestData);
    } else {
      formError.RoleId = "Bạn chưa chọn người quản lý";
    }
    this.setState({ formError: formError });
  }

  UpdateKhachHangUser = (res, element) => {
    var formError = this.state.formError;
    formError = [];
    if (this.state.UserId && this.state.UserId > 0) {
      var requestData = {
        StoreId: this.state.StoreId,
        UserId: this.state.UserId || 0,
        KhachHangIds:  (res.KhachHangId ? [res.KhachHangId] : [])
      }
      this.props.khachhangUserUpdateRequest(requestData);
    } else {
      formError.RoleId = "Bạn chưa chọn người quản lý";
    }
    this.setState({ formError: formError });
  }
  componentDidMount() {
    this.fetchListUser();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.khachhangUser.type == khachhangUserConstant.KHACHHANG_USER_LIST_SUCCESS) {
      let { listUser } = nextProps.khachhangUser;
      this.setState({
        listUser: this.BuildSelectOption(listUser)
      });
    } else if (nextProps.khachhangUser.type == khachhangUserConstant.KHACHHANG_USER_UPDATE_SUCCESS) {
      this.featchDetail();
    } else if (nextProps.khachhangUser.type == khachhangUserConstant.KHACHHANG_USER_DETAIL_SUCCESS) {
      let { khachHangNotUser, khachHangUser, total_record } = nextProps.khachhangUser.item;
      this.setState({ listKhachHangNotUser: khachHangNotUser, listKhachHangUser: khachHangUser, total_record: total_record })
    }
  }
  BuildSelectOption(list) {
    var options = [];
    if (list && list.length > 0) {
      list.map((item) => { options.push({ value: item.UserId, label: item.TenDayDu  +" - "+ item.username}) }
      );
    }
    return options;
  }
  render() {
    const { selectedOption, listUser, listKhachHangNotUser, listKhachHangUser } = this.state;
    const {
      handleSubmit,
      khachhangUser: {
        listRequesting,
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div className="mb-3">
            <Select
              placeholder="Chọn người quản lý"
              value={selectedOption}
              onChange={this.handleUserChange}
              options={listUser}
            />
            <em className="error invalid-feedback">{this.state.formError.RoleId}</em>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 row">
              <div className="col-sm-5">
                <InputGroup>
                  <Input placeholder=" Nhập Mã, Tên, số điện thoại KH" 
                  onChange={this.handleSearchChange.bind(this, "keyword")} 
                  onKeyDown={e => this.keyPress(e)}/>
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" onClick={handleSubmit(this.featchDetail)}>
                      <i className="fa fa-search"></i> Tìm kiếm
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                    <th scope="col" className="text-center">
                    {listKhachHangNotUser && !!listKhachHangNotUser.length && (<CheckboxExt
                          onClick={() => this.checkedKhachHangAll()}
                          chkClass = "cb-item-all"
                          permission={BtnPermissions.KhachHang.ADD_USERS} />
                          )}
                    </th>
                      <th scope="col" width="120" className="text-left">Mã KH</th>
                      <th scope="col" className="text-left">Tên khách hàng</th>
                      <th scope="col" width="10" className="text-left">Thêm</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listKhachHangNotUser && !!listKhachHangNotUser.length && (
                      listKhachHangNotUser.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td scope="row" className="text-center">
                          <CheckboxExt
                          chkClass= "cb-item"
                          onClick={() => this.handleKhachHangClick(res)}
                          checkId = {idx + 1}
                          permission={BtnPermissions.KhachHang.ADD_USERS} />
                        </td>
                          <td className="text-left">{res.Ma}</td>
                          <td className="text-left">{res.Ten} <br></br>  {res.DiaChi? <span className="item_unit">{res.DiaChi}</span> : null }</td>
                          <td className="text-left">
                            <ButtonExt
                              btnClass="text-primary"
                              iconClass="fa-arrow-right fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateKhachHangUser(res)}
                              permission={BtnPermissions.KhachHang.ADD_USERS} />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                {this.state.total_record > this.state.per_page && (
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={this.state.total_record}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                )}
              </div>
              <div className="col-sm-2 text-center">
              <Row>
              <Col sm="12" className="text-center">
              <ButtonExt btnClass="mr-1"
                color="success"
                iconClass="fa fa-arrow-right icon-right"
                displayText="Thêm"
                btnClick={() => this.updateListKhachHangUser("add")}
                permission={BtnPermissions.KhachHang.ADD_USERS} />
                </Col>
              </Row>
              <Row>
              <Col sm="12" className="text-center">
              <ButtonExt btnClass="mr-1"
                color="success"
                iconClass="fa fa-arrow-left"
                displayText="&nbsp;&nbsp;&nbsp;Xóa"
                btnClick={() => this.updateListKhachHangUser("remove")}
                permission={BtnPermissions.KhachHang.ADD_USERS} />
                </Col>
              </Row>

              </div>
              <div className="col-sm-5">
                <InputGroup>
                  <Input placeholder=" Nhập Mã, Tên, số điện thoại KH"  onChange={this.filterListKhachHangUser} />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" >
                      <i className="fa fa-search"></i> Tìm kiếm
                      </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="50" className="text-center">Xóa</th>
                      <th scope="col" width="120" className="text-left">Mã KH</th>
                      <th scope="col" className="text-left">Tên khách hàng</th>
                      <th scope="col" className="text-center">
                    {listKhachHangUser && !!listKhachHangUser.length && (
                        <CheckboxExt
                          onClick={() => this.UnCheckedKhachHangAll()}
                          chkClass = "cb-item-un-all"
                          permission={BtnPermissions.KhachHang.ADD_USERS} />
                          )}
                    </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listKhachHangUser && !!listKhachHangUser.length && (
                      listKhachHangUser.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-center">
                            <ButtonExt
                              btnClass="text-danger"
                              iconClass="fa-arrow-left fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateKhachHangUser(res)}
                              permission={BtnPermissions.KhachHang.ADD_USERS} />
                          </td>
                          <td className="text-left">{res.Ma}</td>
                          <td className="text-left">{res.Ten} <br></br> <span className="item_unit">{res.DiaChi}</span></td>
                          <td scope="row" className="text-center">
                          <CheckboxExt
                          chkClass= "cb-item-un"
                          onClick={() => this.handleUnKhachHangClick(res)}
                          checkId = {idx + 1}
                          permission={BtnPermissions.KhachHang.ADD_USERS} />
                        </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  khachhangUser: state.khachhangUser,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  khachhangUserListRequest: khachhangUserAction.khachhangUserListRequest,
  khachhangUserUpdateRequest: khachhangUserAction.khachhangUserUpdateRequest,
  khachhangUserDetailRequest: khachhangUserAction.khachhangUserDetailRequest,
})(KhachhangUser)
const formed = reduxForm({
  form: 'khachhangUser',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/KhachHang/KhachhangUser.js